import { gql } from '@apollo/client';
import { AllBedSensorCommandsQuery } from '../../__generated__/graphql';

export const allBedSensorCommandsQuery = gql`
  query AllBedSensorCommands(
    $first: Int
    $after: String
    $filters: BedSensorCommandFilters
    $sortBy: [SortBy]
  ) {
    allBedSensorCommands(
      first: $first
      after: $after
      filters: $filters
      sortBy: $sortBy
    ) {
      edges {
        cursor
        node {
          _id
          bedSensorId
          timestampMs
          message
          ok
        }
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const extractAllBedSensorCommands = (data: AllBedSensorCommandsQuery) =>
  data.allBedSensorCommands;
